export interface RFRFProps {
  name?: string;
}

export const getRFRequestFilter = (event: RFRFProps) => {
  return {
    ...(event?.name
      ? {
          nombre: event.name,
        }
      : {}),
  };
};
